/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from 'react';

export default {
  title: 'HSBC simplified Chinese logo',
  viewBox: '0 0 472 143',
  svgContent: (
    <>
      <rect x="71.3" y="0.6" fill="#FFFFFF" width="141.7" height="141.7" />
      <polygon fill="#DB0011" points="213.1,0.6 213.1,142.4 283.9,71.5 " />
      <polygon fill="#DB0011" points="71.3,0.6 142.2,71.5 213.1,0.6 " />
      <polygon fill="#DB0011" points="71.3,0.6 0.5,71.5 71.3,142.4 " />
      <polygon fill="#DB0011" points="71.3,142.4 213.1,142.4 142.2,71.5 " />
      <path
        d="M305.2,59l6.1-7.1c5.7,3.8,11,8.2,15.7,13.2l-6.8,7.1C315.6,67.3,310.6,62.9,305.2,59z M320.5,76.3l9.1,4.7
	c-3.8,10.3-8.7,20.1-14.6,29.2l-9.1-5.8C312.3,96,317.2,86.5,320.5,76.3L320.5,76.3z M307.5,38.6l6.5-6.8
	c5.3,3.4,10.3,7.2,14.9,11.6l-6.8,7.5C317.7,46.2,312.8,42.1,307.5,38.6L307.5,38.6z M383.2,43h-39.4v56.5H384v8.8h-49.6v-74h48.9
	L383.2,43z"
      />
      <path
        d="M393.2,82.8h33.9V71.2H401v-8.8h26.1V50.9h-31.2V42h31.2V31.8h9.9V42h31.2v8.9H437v11.6h26.1v8.8H437v11.6H471v8.9H437v18.7
	h-9.9V91.7h-33.9V82.8z"
      />
    </>
  ),
};
